<template>
  <div class="wecom-gate">
    <div class="gate-card">
      <div class="gate-header">测评已完成</div>
      <div class="gate-title">添加顾问查看报告</div>
      <div class="gate-desc">
        扫描二维码添加企业微信客服，添加成功后可在欢迎语中查看报告。
      </div>
      <div class="gate-qr-wrap">
        <img
          class="gate-qr-bg"
          src="../../../assets/img/test/assiant_2wml.png"
          alt="客服二维码背景"
        />
        <img
          class="gate-qr"
          src="../../../assets/img/test/assiant_2wm111.jpg"
          alt="企业微信客服二维码"
        />
      </div>
      <div class="gate-tip">长按识别或截图后使用微信扫一扫添加客服</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "wecomGate",
};
</script>

<style lang="less" scoped>
.wecom-gate {
  min-height: 100vh;
  padding: 40px 20px;
  background: linear-gradient(180deg, #edf4f5 0%, #d7e5e7 100%);
  box-sizing: border-box;
}

.gate-card {
  max-width: 420px;
  margin: 0 auto;
  padding: 32px 24px 28px;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 12px 40px rgba(66, 104, 110, 0.12);
  text-align: center;
}

.gate-header {
  color: #42686e;
  font-size: 15px;
  letter-spacing: 2px;
}

.gate-title {
  margin-top: 10px;
  color: #24393d;
  font-size: 28px;
  font-weight: 600;
  line-height: 1.35;
}

.gate-desc {
  margin-top: 14px;
  color: #5d7377;
  font-size: 14px;
  line-height: 1.7;
}

.gate-qr-wrap {
  position: relative;
  width: 280px;
  height: 280px;
  margin: 28px auto 0;
}

.gate-qr-bg,
.gate-qr {
  display: block;
  width: 100%;
  height: 100%;
}

.gate-qr {
  position: absolute;
  top: 80px;
  left: 48px;
  width: 184px;
  height: 184px;
}

.gate-tip {
  margin-top: 18px;
  color: #7a8f92;
  font-size: 13px;
  line-height: 1.6;
}
</style>
